var _defs, _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoCt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tile"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 112
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32,
    y: 32,
    width: 448,
    height: 448,
    rx: 112,
    fill: "#72A83D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tile)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 256) scale(0.78)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-18 8) rotate(6)",
    d: "M193.64 -50.02C247.36 157.92 153.45 250.16 -53.5 192.71C-260.45 135.26 -293.37 7.81 -140.14 -142.69C13.09 -293.18 139.92 -257.97 193.64 -50.02Z",
    fill: "#DCFCE7",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(20 -12) rotate(-8)",
    d: "M134.5 137.71C-13.39 282.15 -135.37 247.92 -186.52 47.63C-237.66 -152.67 -147.02 -241.2 52.01 -185.34C251.04 -129.48 282.39 -6.72 134.5 137.71Z",
    fill: "#86EFAC",
    fillOpacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(-5 15) rotate(5)",
    d: "M-59.32 175.23C-247.49 111.53 -271.35 -7.87 -122.1 -138.99C27.16 -270.1 142.49 -231.06 181.41 -36.25C220.34 158.57 128.86 238.93 -59.32 175.23Z",
    fill: "#2F6A17",
    fillOpacity: 0.35
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-107.25 64.75C-107.25 64.75 -107.25 -11.12 -107.25 -11.12C-107.25 -40.74 -83.24 -64.75 -53.62 -64.75C-24.01 -64.75 0 -40.74 0 -11.12C0 -11.12 0 64.75 0 64.75",
    stroke: "#FFFFFF",
    strokeWidth: 45.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 64.75C0 64.75 0 -11.12 0 -11.12C0 -40.74 24.01 -64.75 53.63 -64.75C83.24 -64.75 107.25 -40.74 107.25 -11.12C107.25 -11.12 107.25 64.75 107.25 64.75",
    stroke: "#FFFFFF",
    strokeWidth: 45.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCt);
export default __webpack_public_path__ + "static/media/logo-ct.25a16393af0e006c0c307cb025b9118a.svg";
export { ForwardRef as ReactComponent };